import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uxa8001d',
  templateUrl: './uxa8001d.component.html',
  styleUrls: ['./uxa8001d.component.scss']
})
export class Uxa8001dComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
